import { URL_BACKEND } from "./config";
const request = require("request");

export const getCategoriaFornecedor = ({ token, params }) => {
    return new Promise((resolve, reject) => {
        request(
            {
                headers: {
                    "Content-Type": "application/json",
                    "User-Token": token,
                },
                uri: URL_BACKEND + "/fornecedores/categoria",
                method: "GET",
                qs: params,
            },
            (err, res, body) => {
                resolve({ err: err, res: res, body: body });
            }
        );
    });
};

export const getFornecedoresAtivos = ({ token, filters }) => {
    return new Promise((resolve, reject) => {
        request(
            {
                headers: {
                    "Content-Type": "application/json",
                    "User-Token": token,
                },
                uri: URL_BACKEND + "/fornecedores/ativos",
                method: "GET",
                qs: filters,
            },
            (err, res, body) => {
                resolve({ err: err, res: res, body: body });
            }
        );
    });
};